import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { ErrorState } from '../../components/states';
import PasswordManagementForm from '../../components/forms/PasswordManagementForm';
import ProfileForm from '../../components/forms/ProfileForm';
import Loader from '../../components/Loader';
import { useFetch } from '../../hooks/useFetch';

const ProfilePage = () => {
  const baseUrl = `/v1/client`;

  const { requestApi, data, error } = useFetch(baseUrl);
  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? (
    <Box display="flex" flexDirection="column" gap="16px">
      <ProfileForm defaultValues={data?.data} />
      <PasswordManagementForm />
    </Box>
  ) : (
    <Loader />
  );
};

export default ProfilePage;
